export default function DiamondDivider({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex-1 h-px bg-gradient-to-r from-transparent to-accent opacity-50" />
      <div className="w-2 h-2 bg-accent rotate-45" />
      <div className="flex-1 h-px bg-gradient-to-l from-transparent to-accent opacity-50" />
    </div>
  );
}
